export const PRODUCTS_MENU_ITEM_NAME = "products";

